<script>
import errorsMixin from '@/mixins/errors.mixin'
import DrivingSchoolValidator from "../core/models/drivingSchoolValidator"
import {DrivingSchoolService as Svc} from "../core/driving-school.service"

export default {
  name: 'drivingSchoolRemove',
  mixins: [errorsMixin],
  props: {
    id: Number
  },
  
  render() {
    return this.$scopedSlots.default({
      showing: this.showing,
      toggle: this.toggle,
      formErrors: this.formErrors,
      updateShowing: this.updateShowing,
      send: this.send
    })
  },

  data:() => ({
    showing: false,
    processing: false,
    formData: {
      name: '',
      number: null,
      slug: ''
    }
  }),

  methods: {
    toggle() {
      this.showing = !this.showing
    },

    updateShowing(val) {
      this.showing = val
    },


    async send() {
      try {
        this.processing = true
        let res = await new Svc().remove(this.id)
        this.$emit('remove', this.id)
        this.$notify({text: 'Driving school removed', type: 'success'})
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
      finally {
        this.processing = false
      }
    }
  }
}
</script>